import axios from 'axios';
import iziToast from 'izitoast';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const Counter = ({ targetTime, testId }) => {
  const { apipath, logout } = useAuth();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [isLoading, setIsLoading] = useState(false);

  const calculateTimeLeft = (targetTime) => {
    const now = new Date().getTime();
    console.log(new Date(targetTime));
    const target = new Date(targetTime).getTime();
    const difference = target - now;

    return {
      total: difference,
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };
  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(targetTime));

  useEffect(() => {
    // console.log(targetTime);
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft(targetTime);
      // console.log("time left : "+newTimeLeft.total);
      setTimeLeft(newTimeLeft);

      if (newTimeLeft.total <= 0) {
        iziToast.success({
          'message':'Test is started please click on start button to start your test.',
          'position': 'center'
        });
        clearInterval(timer); // Stop the timer when the target is reached
      }
    }, 1000);

    return () => clearInterval(timer); // Cleanup on component unmount
  }, [targetTime]);

  const startTest = async (tid) => {
    setIsLoading(true);
    try {
      // console.log(tid);
      const response = await axios.post(
        apipath + '/startTest',
        { 'testId': tid },
        {
          headers: {
            Authorization: 'Bearer ' + token
          }
        }
      );
      console.log(response.data);
      if (response.data.status === "true") {
        localStorage.setItem('tId', tid);
        navigate('/user_test', { replace: true });
      }
      if (response.data.status === "submitted") {
        iziToast.warning({
          message: response.data.message,
          position: "topCenter"
        })
      }
      if (response.data.status === "unauthentic") {
        localStorage.removeItem('token');
        navigate('/');
      }
    }
    catch (error) {
      // console.error('Error fetching data:', error);
      if (error.status === 401) {
        iziToast.error({
          message: "Un-Authorised! Please Login.",
          position: "topCenter"
        });
        logout();
      }
      else {
        iziToast.error({
          message: error,
          position: 'topCenter'
        });
      }

    } finally {
      setIsLoading(false);
    }
  }

  // const confirmStart = (uid) => {
  //   iziToast.show({
  //     color: 'green',
  //     message: 'Are you sure to Start Test?',
  //     position: 'topCenter', // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter
  //     buttons: [
  //       [
  //         '<button>Ok</button>',
  //         function (instance, toast) {
  //           startTest(uid);
  //           instance.hide({
  //             transitionOut: 'fadeOutUp'
  //           }, toast);
  //         }
  //       ],
  //       [
  //         '<button>Close</button>',
  //         function (instance, toast) {
  //           instance.hide({
  //             transitionOut: 'fadeOutUp'
  //           }, toast);
  //         }
  //       ]
  //     ]
  //   });
  // }


  return (
    <div>
      {timeLeft.total > 0 ? (
        <h1>
          Start In: {timeLeft.days ? timeLeft.days+"d" : ""} {timeLeft.hours ? timeLeft.hours+"h" : ""} {timeLeft.minutes}m {timeLeft.seconds}s
        </h1>
      ) : (
        <button onClick={() => startTest(testId)} className="bg-green-600 text-white p-2 rounded hover:bg-green-800">Start Test</button>
      )}
    </div>
  );
};

export default Counter;